import React from 'react';
import '../index.css';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="clearMin"></div>
                <div className="footerWrapper">
                    <p>
                        La presente es para los asociados a la Mutual interesados en el Servicio de Ayuda Económica
                        y es únicamente de carácter informativo y orientativo. La otorgación de Ayudas Económicas
                        se encuentra sujeta a las condiciones de aprobación establecidas por nuestra Mutual.
                        Interés con modalidad de sistema Francés, con las siguientes tasas: TNA: 90.00%, TEM: 7.40%, TEA: 138.18%, <span className="bigText">CFT: 140.68%. </span>
                        Más info en <a href="https://www.jerarquicos.com/ayudas-economicas" target="_blank" style={{textDecoration:"underline"}}>nuestra página.</a>
                    </p>
                    <div className="footerInfo">
                        <img src="https://www.jerarquicos.com/wp-content/uploads/2024/03/jerarquicossalud_logo.svg" className="logoFooter" alt="logo"/>
                        <p>
                            © 2025 . Asociación Mutual del Personal Jerárquico de Bancos Oficiales Nacionales
                            Av. Fdo. Zuviría 4584 / 0342 450 4800 - 0800 555 4844 / 3000 Santa Fe. Argentina
                        </p>
                    </div>
                </div>
                <div className="clearMax"></div>
            </footer>
        </>
    )
};

export default Footer;

